export default function (text) {
  text.off("mousedblclick");

  let clickCount = 0;
  let clickTimeout;

  text.on("mouseup", () => {
    clearTimeout(clickTimeout);
    clickCount++;

    clickTimeout = setTimeout(function () {
      clickCount = 0;
    }, 500);

    if (clickCount === 2) {
      text.selectWord();
    }
  });
}
